import moment from "moment";
import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import { Heading6 } from "../../widgets";
import UtilizationChart from "./UtilizationChart";

const UtilizationModal = (props) => {
  const { show, onHide, eg, searchParams } = props;
  const [size, setSize] = useState("modal-fs vw-100");

  useEffect(() => {
    const fromDate = moment(searchParams.custom.from);
    const toDate = moment(searchParams.custom.to);
    const diff = toDate.diff(fromDate, "days") + 1;

    diff <= 20 ? setSize("modal-form") : setSize("modal-fs vw-100");
  }, [searchParams]);

  return (
    <div>
      {props.eg !== null && (
        <Modal show={show} onHide={onHide} className={size} size="lg">
          <Modal.Header closeButton onClick={onHide}>
            <Modal.Title>
              <Heading6>
                <span style={{ color: "grey" }}> Utilization % |</span>
                <span className="text-primary"> {eg.egName}</span>
              </Heading6>
            </Modal.Title>
          </Modal.Header>
          <Modal.Body className="py-0">
            <UtilizationChart egId={eg.egId} searchParams={searchParams} />
          </Modal.Body>
        </Modal>
      )}
    </div>
  );
};

export default UtilizationModal;
